module.exports = __webpack_public_path__ + "static/media/STVid1.3da2770e.mp4";